import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.getHeight
import com.github.chosamuel.kishibe.application.getWidth
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.matterjs.body.Body
import com.github.chosamuel.matterjs.constraint.Constraint
import com.github.chosamuel.matterjs.core.Matter
import com.github.chosamuel.matterjs.jsObject
import kotlin.math.PI
import kotlin.math.sin
import kotlin.random.Random

fun Application.createChimes(
    beam: Rect,
    numChimes: Int = 6,
    chimeWidth: Double = 20.0
): List<Rect> {
    val chimes = mutableListOf<Rect>()
    val spacing = (beam.width - (chimeWidth*numChimes)) / (numChimes-1.0) + chimeWidth
    val distanceToBeam = getHeight()*0.125
    val sinOffset = Random.nextDouble(PI*2.0)
    repeat(numChimes){
        val chimeHeight = (getHeight()*0.4) + (sin(it*1.0+sinOffset)*getHeight()*0.20)
        val x = (getWidth()*0.5) - (beam.width*0.5)  + (spacing*it) + (chimeWidth * 0.5)
        val y = beam.center.y + distanceToBeam + (chimeHeight*0.5)
        val chime = Rect(
            Vector2(x,y),
            chimeWidth,
            chimeHeight,
            jsObject {
                restitution = 1.0
                friction = 0.5
                frictionAir = 0.001
            }
        )
        chimes.add(chime)
    }
    return chimes
}

fun Application.createChimeConnections(beam: Body, chimes: List<Rect>): List<Constraint>{
    val constraints = mutableListOf<Constraint>()
    chimes.forEach {
        val xOffset = it.body.position.x -beam.position.x
        val c = Matter.Constraint.create(jsObject {
            bodyA = beam
            pointA = jsObject {
                x = xOffset
                y = 0.0
            }
            bodyB = it.body
            pointB = jsObject {
                x = 0.0
                y = -it.height*0.5
            }
        })
        constraints.add(c)
    }
    return constraints
}